<!-- LAYOUT: default.vue -->
<!-- Minimal Nuxt layout — wraps the page slot in v-app and configures the favicon. -->

<script setup lang="ts">
//
// Composables
//
const config = useRuntimeConfig();

// Configure favicon for reverse proxy deployment
useHead({
  link: [
    {
      rel: "icon",
      type: "image/x-icon",
      href: pathCombine(config.public.APP_BASE_URL, "/favicon.ico"),
    },
  ],
});
</script>

<template>
  <v-app>
    <slot />
  </v-app>
</template>
